export default "__VITE_ASSET__4c9a0032__"